import { createAction, props } from '@ngrx/store';
import { RuleTypeData } from '@app/Shared/interfaces/iRuleTypes';

// Load Rule Types Actions
export const loadRuleTypes = createAction('[RULE_TYPES] LOAD_RULE_TYPES');
export const loadRuleTypesSuccess = createAction('[RULE_TYPES] LOAD_RULE_TYPES_SUCCESS', props<{ ruleTypes: RuleTypeData[] }>());
export const loadRuleTypesFailure = createAction('[RULE_TYPES] LOAD_RULE_TYPES_FAILURE', props<{ error: string }>());

// Create Rule Type Actions
export const createRuleType = createAction('[RULE_TYPES] CREATE_RULE_TYPE', props<{ ruleTypeData: RuleTypeData }>());
export const createRuleTypeSuccess = createAction('[RULE_TYPES] CREATE_RULE_TYPE_SUCCESS', props<{ ruleType: RuleTypeData }>());
export const createRuleTypeFailure = createAction('[RULE_TYPES] CREATE_RULE_TYPE_FAILURE', props<{ error: string }>());

// Update Rule Type Actions
export const updateRuleType = createAction('[RULE_TYPES] UPDATE_RULE_TYPE', props<{ key: number; ruleTypeData: RuleTypeData }>());
export const updateRuleTypeSuccess = createAction('[RULE_TYPES] UPDATE_RULE_TYPE_SUCCESS', props<{ ruleType: RuleTypeData }>());
export const updateRuleTypeFailure = createAction('[RULE_TYPES] UPDATE_RULE_TYPE_FAILURE', props<{ error: string }>());

// Delete Rule Type Actions
export const deleteRuleType = createAction('[RULE_TYPES] DELETE_RULE_TYPE', props<{ key: number }>());
export const deleteRuleTypeSuccess = createAction('[RULE_TYPES] DELETE_RULE_TYPE_SUCCESS', props<{ key: number }>());
export const deleteRuleTypeFailure = createAction('[RULE_TYPES] DELETE_RULE_TYPE_FAILURE', props<{ error: string }>());

// Select Rule Type Actions
export const selectRuleType = createAction('[RULE_TYPES] SELECT_RULE_TYPE', props<{ ruleType: RuleTypeData | null }>());
export const clearSelectedRuleType = createAction('[RULE_TYPES] CLEAR_SELECTED_RULE_TYPE');
